import { AnimatePresence } from 'framer-motion'
import {
  FC,
  createContext,
  useContext,
  ReactNode,
  useState,
  Dispatch,
  SetStateAction,
} from 'react'

import { Loader } from 'components/loader'

export type AppContextType = {
  isHome: boolean
  isPageVisible: boolean
  isLoading: boolean
  setLoading: Dispatch<SetStateAction<boolean>>
}

const AppContext = createContext<AppContextType | null>(null)

export const AppContextProvider: FC<
  {
    children?: ReactNode | ReactNode[]
  } & Pick<AppContextType, 'isHome'>
> = ({ children, isHome }) => {
  const [isLoading, setLoading] = useState(true)
  const [isPageVisible, setPageVisible] = useState(false)

  return (
    <AppContext.Provider
      value={{ isHome, isLoading, setLoading, isPageVisible }}
    >
      <AnimatePresence onExitComplete={() => setPageVisible(true)} mode="wait">
        {isLoading && <Loader />}
      </AnimatePresence>
      {children}
    </AppContext.Provider>
  )
}

export const useAppContext = () => {
  const context = useContext(AppContext)
  return context as AppContextType
}
